<template src="./home.html"></template>

<script>
import { onMounted } from "vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
import ElencoOrdini from "./ElencoOrdini.vue";

export default {
  name: "HomePage",

  components: {
    ElencoOrdini
  },

  setup() {
    const router = useRouter();

    const loading = ref(false);
    const init = async () => {
    };


    onMounted(() => {
      init();
    });

    return {
      init,
      loading,
      router,
    };
  },
};
</script>
